import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";
import { useSelector } from "react-redux";
import AppInput from "components/ui/AppInput";
import AppButton from "components/ui/AppButton";
import AppOutlineButton from "components/ui/AppOutlineButton";
const RefundForm = ({ closeModal, onSubmit, loading, order }) => {
  const { t } = useTranslation();
  const { currentLanguage } = useSelector((state) => state.LanguageSlice);
  const [values, setValues] = React.useState({ reason: "", amount: "" });
  const [errors, setErrors] = React.useState({ reason: "", amount: "" });

  const validate = () => {
    const nextErrors = { reason: "", amount: "" };
    let isValid = true;
    const amount = Number(values.amount);

    if (!values.reason?.trim()) {
      nextErrors.reason = t("Please enter refund reason");
      isValid = false;
    }
    if (values.amount === "" || Number.isNaN(amount)) {
      nextErrors.amount = t("Please enter refund amount");
      isValid = false;
    } else if (amount < 2) {
      nextErrors.amount = t("Minimum refund amount can be 2");
      isValid = false;
    } else if (amount > Number(order?.totalOrderPrice || 0)) {
      nextErrors.amount = t("Maximum refund amount can be", {
        amount: order?.totalOrderPrice,
      });
      isValid = false;
    } else if (!/^\d+(\.\d{1,2})?$/.test(String(values.amount))) {
      nextErrors.amount = t("Maximum 2 decimal points allowed");
      isValid = false;
    }

    setErrors(nextErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    onSubmit({
      order,
      reason: values.reason.trim(),
      amount: Number(values.amount),
    });
  };
  return (
    <Spin spinning={loading}>
      <div className="relative mx-auto my-auto w-full bg-white p-2">
        <div className="my-2 space-y-4">
          <div className="grid grid-cols-2 gap-2 rounded-xl border border-gray-200 p-3 text-sm">
            <div className="text-gray-500">{t("Order")} #</div>
            <div className="text-right font-medium">{order?.orderNumber}</div>
            <div className="text-gray-500">{t("Status")}</div>
            <div className="text-right font-medium">{order?.orderStatus}</div>
            <div className="text-gray-500">{t("Max Allowed (Order Total Price)")}</div>
            <div className="text-right font-medium">
              {new Intl.NumberFormat(currentLanguage, {
                style: "currency",
                currency: "AED",
              }).format(order?.totalOrderPrice || 0)}
            </div>
            <div className="text-gray-500">{t("Store")}</div>
            <div className="text-right font-medium">
              {order?.storeInfo?.baseLanguage?.name}
            </div>
            <div className="text-gray-500">{t("Whatsapp Number")}</div>
            <div className="text-right font-medium" dir="ltr">
              {order?.userInfo?.phoneNumber}
            </div>
          </div>

          <div className="grid gap-3 sm:grid-cols-2">
            <AppInput
              label={t("Refund Reason")}
              value={values.reason}
              onChange={(e) =>
                setValues((prev) => ({ ...prev, reason: e.target.value }))
              }
              error={errors.reason}
              mandatory={true}
              placeholder={t("Refund Reason")}
            />
            <AppInput
              label={t("Refund Amount")}
              type="number"
              value={values.amount}
              onChange={(e) =>
                setValues((prev) => ({ ...prev, amount: e.target.value }))
              }
              error={errors.amount}
              mandatory={true}
              placeholder={t("Refund Amount")}
            />
          </div>

          <div className="mt-2 flex justify-end gap-2">
            <AppOutlineButton disabled={loading} onClick={closeModal}>
              {t("Cancel")}
            </AppOutlineButton>
            <AppButton disabled={loading} onClick={handleSubmit}>
              {t("Submit")}
            </AppButton>
          </div>
        </div>
      </div>
    </Spin>
  );
};
export default RefundForm;
